import { baseSchema, baseObjectSchema } from '../baseSchemas';
import { z } from 'zod';

export const warehouseSchema = baseObjectSchema.extend({
  name: z.string(),
  code: z.string(),
  address: z.string().optional(),
  city: z.string().optional(),
  companySiteId: z.string(),
  companySite: baseSchema.optional(),
  isLogistics: z.boolean(),
});

export const getWarehousesSchema = z.array(warehouseSchema);

export type GetWarehousesResponse = z.infer<typeof getWarehousesSchema>;
